module.exports = __webpack_public_path__ + "static/img/201.49e9783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200818/201.jpg
// module id = 0aQm
// module chunks = 0